import { styled, theme } from "../../../../../../styles/stitches.config"
import { ReactNode } from "react"
import {
  BusinessDisclaimerStyled,
  DisclaimerContainer,
  BusinessDisclaimerText,
  HouseholdDisclaimerStyled,
} from "./ContractSelection.styled"
import { ContactButtonStyled } from "./ContractSelectionButtons.styled"
import { Warning } from "../../../../../../images/xd/icons"
import { Controller, useFormContext } from "react-hook-form"
import { Checkbox } from "../../../acquisitionFormNew/components/Checkbox"
import Text from "../../../../../../components/Text"
import { Spacer } from "../../../../../../components/spacer/Spacer"
import Separator from "../../../../../../components/Separator"
import { useTranslation } from "react-i18next"
import { WEB_LINKS } from "../../../../../../constants/links"
import { ContractTypeFormValues } from "../../../acquisitionFormNew/contractType/contractTypeForm.utils"
import { FormItem } from "../../../acquisitionFormNew/components/Form"

interface Props {
  children: ReactNode
}

const DisclaimerIcon = styled(Warning, {
  color: theme.colors.warning.value,
  position: "absolute",
  top: theme.space.s8,

  "@sm": {
    top: theme.space.s6,
    left: theme.space.s6,
  },
})

function ContactButton() {
  return (
    <a target="_blank" href={WEB_LINKS.contact} rel="noreferrer">
      <ContactButtonStyled type="button">Kontaktujte nás</ContactButtonStyled>
    </a>
  )
}
export function SelectionDisclaimer({ children }: Props) {
  return <DisclaimerContainer>{children}</DisclaimerContainer>
}

export function BusinessSelectionDisclaimer() {
  return (
    <BusinessDisclaimerStyled>
      <Warning width={69} height={36} style={{ color: theme.colors.warning.value }} />
      <BusinessDisclaimerText>Spotřebujete nebo vyrobíte více než 100 MWh ročně?</BusinessDisclaimerText>
      <ContactButton />
    </BusinessDisclaimerStyled>
  )
}

export function HouseholdSelectionDisclaimerNew() {
  const { control } = useFormContext<ContractTypeFormValues>()
  const { t } = useTranslation("acquisitionForm")

  return (
    <>
      <HouseholdDisclaimerStyled direction="column">
        <DisclaimerIcon width={theme.sizes.s5_5.value} height={theme.sizes.s5_5.value} />
        <Text
          type="headerH5Warning"
          css={{
            fontSize: theme.fontSizes.medium,
            paddingLeft: theme.space.s9,
            marginBottom: theme.space.s6,

            "@sm": {
              paddingLeft: "0",
              marginBottom: theme.space.s6,
            },
          }}
        >
          {t("do_you_have_measurement_type_b_header")}
        </Text>
        <Text type="textsSmall" css={{ lineHeight: "21px" }}>
          {t("do_you_have_measurement_type_b_description")}
        </Text>
        <Spacer size={theme.space.s8} />
        <Separator orientation="horizontal" />
        <Spacer size={theme.space.s6} />
        <Controller
          control={control}
          name="measurementTypeConsent"
          render={({ field, fieldState }) => (
            <FormItem>
              <Checkbox
                error={fieldState.error?.message}
                label={
                  <Text type="headerH4" css={{ display: "block", maxWidth: "200px", "@sm": { maxWidth: "100%" } }}>
                    Mám průběhové měření (měření typu B).
                  </Text>
                }
                checkboxCheckedColor="warning"
                errorMsgCSS={{ paddingLeft: theme.space.s12_5 }}
                {...field}
              />
            </FormItem>
          )}
        />
      </HouseholdDisclaimerStyled>
    </>
  )
}
